<app-card
  [partialFullHeight]="true"
  size="large"
  [spacingBottom]="Spacing.NONE"
>
  <app-title-section
    [size]="2"
    [spacingBottom]="16"
    [title]="'account.resourcesTitle' | translate"
    [body]="'account.resourcesBody' | translate"
  ></app-title-section>
  @if (tenantResources) { @if (tenantResources.OnboardingFiles?.length) {
  <app-title-section
    [size]="3"
    [spacingBottom]="16"
    [title]="'account.onboardingFiles' | translate"
    [body]="'account.onboardingFilesBody' | translate"
  ></app-title-section>
  <ul class="list-section">
    @for (file of tenantResources.OnboardingFiles; track file.name) {
    <li class="file-row" (click)="openUrl(file.url)">
      <div class="icon-wrapper">
        @if (file.type === 'MOVIE') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-file-play-icon lucide-file-play"
        >
          <path
            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
          />
          <path d="M14 2v5a1 1 0 0 0 1 1h5" />
          <path
            d="M15.033 13.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56v-4.704a.645.645 0 0 1 .967-.56z"
          />
        </svg>
        } @else if (file.type === 'IMG') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-image-down-icon lucide-image-down"
        >
          <path
            d="M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21"
          />
          <path d="m14 19 3 3v-5.5" />
          <path d="m17 22 3-3" />
          <circle cx="9" cy="9" r="2" />
        </svg>
        } @else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-file-down-icon lucide-file-down"
        >
          <path
            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
          />
          <path d="M14 2v5a1 1 0 0 0 1 1h5" />
          <path d="M12 18v-6" />
          <path d="m9 15 3 3 3-3" />
        </svg>
        }
      </div>
      <p class="file-text">{{ file.name }}</p>
    </li>
    }
  </ul>
  } @if (tenantResources.ChallengeToolkit?.length) {
  <app-title-section
    [size]="3"
    [spacingBottom]="16"
    [title]="'account.challengeToolkit' | translate"
    [body]="'account.challengeToolkitBody' | translate"
  ></app-title-section>

  <ul class="list-section">
    @for (file of tenantResources.ChallengeToolkit; track file.name) {
    <li class="file-row" (click)="openUrl(file.url)">
      <div class="icon-wrapper">
        @if (file.type === 'MOVIE') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-file-play-icon lucide-file-play"
        >
          <path
            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
          />
          <path d="M14 2v5a1 1 0 0 0 1 1h5" />
          <path
            d="M15.033 13.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56v-4.704a.645.645 0 0 1 .967-.56z"
          />
        </svg>
        } @else if (file.type === 'IMG') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-image-down-icon lucide-image-down"
        >
          <path
            d="M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21"
          />
          <path d="m14 19 3 3v-5.5" />
          <path d="m17 22 3-3" />
          <circle cx="9" cy="9" r="2" />
        </svg>
        } @else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-file-down-icon lucide-file-down"
        >
          <path
            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
          />
          <path d="M14 2v5a1 1 0 0 0 1 1h5" />
          <path d="M12 18v-6" />
          <path d="m9 15 3 3 3-3" />
        </svg>
        }
      </div>
      <p class="file-text">{{ file.name }}</p>
    </li>
    }
  </ul>
  } } @if(isLoading()){
  <app-spinner data-test-id="account-manage-spinner"></app-spinner>
  } @else if (errorMessage()) {
  <p class="error-message">{{ errorMessage() }}</p>
  }
</app-card>
